<template>
    <app-layout title="Home">
    
    <template #fluid>
        <div class="w-100 py-3" style="background-color:#fbfbfb;">
            <div class="container" >
                <div class="row">
                    <div class="col-md-3">
                        <sidebar-category/>
                    </div>
                    <div class="col-md-9">

                       <search-bar/>

                        <bs-carousel/>
                    </div>
                </div>
            </div> 
        </div> 

         <header class="d-flex py-5 bg-white">
            <div class="container text-primary">
             <h4 ><b>Latest Product</b></h4>
            </div>
        </header>

         <div class="bg-light">
         <div class="container">
            <product-grid/>
        </div>
        </div>

    </template>

      
    </app-layout>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout'
    import BsCarousel from '@/Layouts/BsCarousel'
    import ProductGrid from '@/Layouts/ProductGrid'
    import SidebarCategory from '@/Layouts/SidebarCategory'
    import SearchBar from '@/Layouts/SearchBar'

    export default {
        components: {
            AppLayout,
            BsCarousel,
            ProductGrid,
            SidebarCategory,
            SearchBar
        },
    }
</script>